import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"cake"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M4 11H20V21H4V11Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M4 21H20V16H18L15 17L12 16L9 17L6 16H4V21Z"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M8 6V11M12 6V11M16 6V11M7.99805 2.99805H8.00195V3.00195H7.99805V2.99805ZM11.998 2.99805H12.002V3.00195H11.998V2.99805ZM15.998 2.99805H16.002V3.00195H15.998V2.99805Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M2 21H22M4 16H6L9 17L12 16L15 17L18 16H20M4 11H20V21H4V11Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Cake = Vue.extend<IconProps>({
  name: 'CakeIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'cake',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Cake;
